<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1100px"
      line-form
      unit="其他应收单"
      edit-title
      id-key="OtherReceivId"
      :data="data"
      :get-data-func="api.info"
      form-label-width="95px"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @opened="onOpened"
      :form-rules="rules"
      :before-save="onBeforeSave"
      :save-func="()=>{}"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="isMB?24:6">
              <el-form-item label="单据编号" prop="DocNo">
                <span v-if="Mode==0" class="detail-span">{{data.DocNo}}</span>
                <el-input v-else v-model="data.DocNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="单据日期" prop="DocDate">
                <el-date-picker
                  v-model="data.DocDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="业务类型" prop="BusinessTypeId">
                <business-select
                  v-model="data.BusinessTypeId"
                  :params="{Kind:'应收',SourceType:'其他应收单'}"
                  @change="setType"
                />
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="往来单位" prop="TradeUnitId" :rules="data.NeedTradeUnit?tu:null">
                <select-input
                  placeholder="请选择单位"
                  :label="data.TradeUnitName"
                  v-model="data.TradeUnitId"
                  @click="openTradeunit"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:6">
              <el-form-item label="收款到期日" prop="LastDate">
                <el-date-picker
                  v-model="data.LastDate"
                  placeholder="请选择日期"
                  value-format="yyyy-MM-dd"
                  :editable="false"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="经办人" prop="Manager">
                <select-input
                  placeholder="请选择经办人"
                  :label="data.ClerkName"
                  v-model="data.ClerkId"
                  @click="openEmp"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                <el-input type="textarea" v-model="data.Remark" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="row-tb-head" style="margin-top: 10px;">
          <span>单据明细</span>
          <div style="float: right;">
            <el-button type="primary" icon="el-icon-plus" @click="add">添加</el-button>
          </div>
        </div>
        <el-table class="table-line tb-c-head" show-summary :data="data.RpOtherReceivDts" border>
          <el-table-column label="摘要" align="center" min-width="200">
            <template slot-scope="{row}">
              <el-select v-model="row.Abstract" allow-create filterable @change="onChange(row)">
                <el-option v-for="(i,key) in Abstract" :key="key" :label="i" :value="i"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="项目" align="center" min-width="140">
            <!-- <template slot-scope="{row}">
              <item-select v-model="row.ItemName" :source="DItems" @select="onSelect($event,row)" />
            </template> -->
          </el-table-column>
          <el-table-column prop="Amount" label="金额" align="center" width="120">
            <template slot-scope="{row}">
              <el-input @input="onInput(row)" v-model="row.Amount"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60px">
            <template slot-scope="{row, $index}">
              <el-button type="text" @click="del(row, $index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="save">保 存</el-button>
        <el-button @click="close">关 闭</el-button>
      </template>
      <!-- 后面补充 -->
      <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
      <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
// import businessSelect from "@/components/basedoc/business/select";
import tradeunitDialog from "@/components/basedata/business/come/listDialog";
import empDialog from "@/components/personnel/result/record/listDialog";
// import itemSelect from "@/components/basedoc/item/select";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    // businessSelect,
    tradeunitDialog,
    empDialog,
    // itemSelect,
  },
  data() {
    return {
      api: require("@/api/rp/otherReceiv").default,
      code_api: require("@/api/sy/serialCode").default,
      abstract_api: require("@/api/ba/abstract").default,
      item_api: require("@/api/ba/item").default,
      data: {
        OtherReceivId: 0,
        DocNo: "",
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        BusinessTypeId: null, //业务类型
        LastDate: null, //付款到期日
        ClerkId: null, //经办人
        ClerkName: "",
        // Amount: null, //金额
        // TaxAmount: null, //税额
        // IncTaxAmount: null, //含税金额
        Remark: "",
        NeedTradeUnit: true,
        RpOtherReceivDts: [],
      },
      Mode: 0,
      Abstract: [], //摘要
      DItems: [], //项目
      DelRpOtherReceivDts: [],
      isMB: this.$store.state.isMB,
      rules: {
        DocNo: [{ required: true, message: "单据编号不能为空" }],
        DocDate: [{ required: true, message: "单据日期不能为空" }],
        BusinessTypeId: [{ required: true, message: "请选择业务类型" }],
        LastDate: [{ required: true, message: "付款到期日不能为空" }],
        ClerkId: [{ required: true, message: "请选择经办人" }],
      },
      tu: [{ required: true, message: "请选择单位" }],
    };
  },
  methods: {
    onCreateOpened() {
      var user = this.$store.state.user;
      // console.log("user", JSON.parse(JSON.stringify(user)));
      if (user) {
        this.data.ClerkId = user.empId;
        this.data.ClerkName = user.name;
      }
      this.code_api.previewNo("其他应收单").then((res) => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode;
          this.data.DocNo = res.Data.PreviewNo;
        } else {
          this.$message.warning("获取其他应收单编号失败");
        }
      });
    },
    onEditOpened(row) {},
    onOpened() {
      this.abstract_api.list({ SourceType: "其它应收单" }).then((res) => {
        if (res.Code == 0) this.Abstract = res.Data.map((x) => x.Abstract);
      });
      this.item_api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.DItems = res.Data;
      });
    },
    setType(data) {
      if (data) this.data.NeedTradeUnit = data.NeedTradeUnit;
      else this.data.NeedTradeUnit = true;
      this.$refs.dialog.clearValidate();
    },
    openTradeunit() {
      this.$refs.tradeunitDialog.open().then((that) => {
        that.getData();
      });
    },
    setTradeunit(data) {
      this.data.TradeUnitId = data.TradeUnitId;
      this.data.TradeUnitName = data.FullName;
    },
    openEmp() {
      this.$refs.empDialog.open().then((that) => {
        that.getData({ Status: 1 });
      });
    },
    setEmp(data) {
      this.data.ClerkId = data.EmpId;
      this.data.ClerkName = data.EmpName;
    },
    onSelect(e, row) {
      row.T = row.T == 0 ? 0 : 1;
      row.ItemId = e.ItemId;
      row.ItemName = e.ItemName;
    },
    onChange(row) {
      row.T = row.T == 0 ? 0 : 1;
    },
    onInput(row) {
      row.T = row.T == 0 ? 0 : 1;
      row.Amount = this.$commonJs.obj.toNumber(row.Amount);
    },
    add() {
      this.data.RpOtherReceivDts.push({
        OtherReceivDtsId: 0,
        OtherReceivId: this.data.OtherReceivId,
        // AbstractId: null,
        Abstract: "", //摘要
        ItemId: null,
        ItemName: "",
        Amount: null,
        // IncTaxAmount: null,
        // TaxAmount: null,
        // WriteoffAmount: null,
        Remark: "",
        T: 0,
      });
    },
    del(row, index) {
      if (row.T != 0) this.DelRpOtherReceivDts.push({ ...row, T: 2 });
      this.data.RpOtherReceivDts.splice(index, 1);
    },
    onBeforeSave() {
      if (this.data.RpOtherReceivDts.length == 0) {
        this.$message.warning("单据明细不能为空");
        return false;
      }

      var abstract = this.data.RpOtherReceivDts.every((x) => !!x.Abstract);
      if (!abstract) {
        this.$message.warning("单据明细 - 摘要不能为空");
        return false;
      }
      var itemId = this.data.RpOtherReceivDts.every((x) => !!x.ItemId);
      if (!itemId) {
        this.$message.warning("单据明细 - 项目不能为空");
        return false;
      }
      var amount = this.data.RpOtherReceivDts.every((x) => !!x.Amount);
      if (!amount) {
        this.$message.warning("单据明细 - 金额不能为空");
        return false;
      }

      var data = this.$commonJs.obj.removeNullKey(this.data);
      data.RpOtherReceivDts = this.data.RpOtherReceivDts.filter(
        (x) => x.T != null
      );
      this.DelRpOtherReceivDts.forEach((x) => data.RpOtherReceivDts.push(x));

      this.$refs.dialog.isLoading = true;
      this.api.save(data).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.data.RpOtherReceivDts = [];
      this.DelRpOtherReceivDts = [];
    },
  },
};
</script> 